export default __webpack_public_path__ + "static/media/Automotive.dbfd6e78.jpg";